import {
  Divider, List,
  ListItem, ListItemIcon, ListItemText, Popover
} from "@material-ui/core";

import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import { Gesture, Home, Print, RotateLeft } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import ColorButton from "components/common/ColorButton";
import NotificationIcon from "components/notification/NotificationIcon";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import UserAvatar from "components/user/UserAvatar";
import UserName from "components/user/UserName";
import { format } from "date-fns";
import {
  drawerWidth,
  notificationTime,
  platformName
} from "libs/configs/constant";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import useAuth from "libs/hooks/useAuth";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import {
  getNotifications,
  readNotifications,
  selectUnReadNotification,
  trashNotifications
} from "redux/modules/userNotificationSlice";
import { getSmartForm, setSmartServiceId } from "redux/modules/visaForm";
import AuthService from "services/AuthService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundImage: `linear-gradient(to bottom, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
  },
  list: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    paddingBottom: theme.spacing(2),
  },
  logoutButton: {
    marginTop: theme.spacing(2),
  },
  emp: {
    display: "flex",
    flex: 1,
  },
  fullList: {},
  listItemText: {
    color: theme.palette.common.white,
  },
  line: {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
  userInfoSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  // ----
  rowMenuPopOver: {
    // padding: 15,
    width: 350,
  },
  rowPopTitle: {
    padding: "15px",
    borderBottom: "1px solid lightgray",
    fontWeight: "500",
    color: "white",
    textAlign: "center",
    backgroundColor: "#F53C56",
    marginBottom: 15,
  },
  rowPopItem: {
    display: "flex",
    padding: "10px 15px",
    borderBottom: "1px solid lightgray",
  },
  firstItem: {
    flex: 1,
  },
  itemTitle: {
    color: "#5F5F5F",
    fontWeight: "bold",
  },
  itemDesc: {
    color: "#5F5F5F",
    fontSize: "0.8rem",
    paddingTop: "10px",
    fontWeight: "500",
  },
  itemDate: {
    color: "#ABAFC9",
    fontSize: "0.8rem",
    paddingTop: "10px",
    fontWeight: "500",
  },
  secItem: {
    width: 23,
    color: "#F53C56",
    cursor: "pointer",
  },
  noNoti: {
    textAlign: "center",
    color: "#ABAFC9",
    paddingBottom: "18px",
  },
  warpNav: {
    backgroundColor: "#2C8AB9",
    marginTop: 15,
    color: "white",
  },
  textNav: {
    fontSize: 14,
  },
  navIcon: {
    color: "white",
    // fontSize:
  },
  paddingList: {
    padding: theme.spacing(2),
  }
}));

function UserInfoSection({ count = 0, onClickNoti = () => { } }) {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.flexRow}>
        {/* <SwitchLanguage /> */}
        <div></div>
        <div onClick={onClickNoti}>
          <NotificationIcon className={classes.userInfo} count={count} />
        </div>
      </div>
      <div className={classes.userInfoSection}>
        <UserAvatar size={7} />
        <UserName />
        {/* <UserRole /> */}
      </div>
    </div>
  );
}

export default function SidebarLeft(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { accessToken } = useAuth();
  const isOfflineLogin = useSelector((state) => state.auth.isOfflineLogin);
  const { TypeOfUser } = useAuth();
  const { list: notifications } = useSelector(
    (state) => state.userNotification
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const unread = useSelector(selectUnReadNotification);
  const open = Boolean(anchorEl);
  const { personalId } = usePersonalDetail();

  useEffect(() => {
    if (!accessToken) return;

    dispatch(getNotifications());
    const interval = setInterval(() => {
      dispatch(getNotifications());
    }, notificationTime);
    return () => clearInterval(interval);
  }, [dispatch, accessToken]);

  const handleClickLogout = () => {
    if (isOfflineLogin) {
      history.replace("/logout");
    } else {
      history.replace("/logout");
      // logoutRedirect();
    }
  };

  const handleDrawerClose = () => {
    props.onDrawerClose();
  };

  const popoverClick = async (e) => {
    if (open) {
      setAnchorEl(null);
    } else {
      setAnchorEl(e.currentTarget);
      if (unread.length > 0) {
        const body = {
          deviceId: platformName,
          notificationIds: unread.map((x) => x.notificationId),
        };
        await dispatch(readNotifications(body));
        await dispatch(getNotifications());
      }
    }
  };

  const popoverLeave = async () => {
    setAnchorEl(null);
  };

  const removeNotificaiton = async (notificationId) => {
    const body = {
      deviceId: platformName,
      notificationIds: [notificationId],
    };

    await dispatch(trashNotifications(body));
    await dispatch(getNotifications());
  };

  const handleClickNotiItem = (noti) => async () => {
    if (noti.type === "RequestDocuments" && noti?.data !== null) {
      try {
        const notiData = JSON.parse(noti.data);

        setAnchorEl(null);
        dispatch(
          setHomeTab(HOME_TAB.CHECK_STATUS)
        );
        dispatch(setSmartServiceId(notiData.smartServiceId));
        dispatch(
          getSmartForm({
            personalId: notiData.personalId,
            smartserviceId: notiData.smartServiceId,
            draftId: notiData.draftId,
          })
        );
      } catch (e) {
        console.log("handleClickNotiItem ", e);
      }
    }
    if (noti.type === "Stamped" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      // history.push(`/appointment/${notiData?.DraftId}`);
    }
    if (noti.type === "ConfirmStamped" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      // history.push(`/appointment/${notiData?.DraftId}?stamped=1`);
    }

    if (noti.type === "FinalApproved" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/preApprove/${notiData?.draftId}`);
    }

    if (noti.type === "ApprovedStamp" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      // history.push(`/appointment/${notiData?.DraftId}?stamped=1`);
    }

    if (noti.type === "UploadHealthInsurance" && noti?.data !== null) {
      try {
        const notiData = JSON.parse(noti.data);

        setAnchorEl(null);
        dispatch(setHomeTab(HOME_TAB.CHECK_STATUS));
        dispatch(setSmartServiceId(notiData.SmartServiceId));
        await dispatch(
          getSmartForm({
            personalId: notiData.PersonalId,
            smartserviceId: notiData.SmartServiceId,
            draftId: notiData.draftId,
          })
        );
        dispatch(setSmartFormStep(SMART_T_STEP.HEALTH_INSUANCE));
      } catch (e) {
        console.log("handleClickNotiItem ", e);
      }
    }
  };

  const onHome = () => {
    history.push('/')
  }

  const onResetDWP = () => {
    MySwal.fire({
      title: 'Confirmation',
      text: 'Would you like to reset your DWP password?',
      icon: "question",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Confirm',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return AuthService.resetDWPPassword(personalId)
          .then(response => {
            console.log('response ', response.status)
            if (!response.status) {
              throw new Error(response.message)
            }
            //return response.json()
          })
          .catch(error => {
            MySwal.fire(
              "Error!",
              error?.message ?? JSON.stringify(error),
              "error"
            )
            throw new Error(error)
          })
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        return MySwal.fire(
          "Success!",
          "Reset your DWP password successfully !",
          "success"
        )
      }

    });
  }

  const onClickSignature = () => {
    history.push(`/personal/${personalId}/signature`)
  }

  const onClickDWPLink = async () => {
    const res = await AuthService.getDWPLink(personalId)

    window.open(
      res?.results?.dwp_copy,
      "_blank"
    );
  }

  return (
    <div style={{ width: drawerWidth }}>
      <Drawer
        variant="permanent"
        anchor="left"
        BackdropProps={{ invisible: true }}
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        {...props}
      >
        <div className={classes.list}>

          <div className={classes.paddingList}>
            <UserInfoSection
              onClickNoti={(e) => popoverClick(e)}
              count={unread.length}
            />
            <Divider className={classes.line} />
          </div>
          <div className={classes.warpNav}>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              <ListItem button onClick={onHome}>
                <ListItemIcon style={{ color: 'white' }}>
                  <Home />
                </ListItemIcon>
                <ListItemText
                  primary="Home"
                  classes={{ primary: classes.textNav }}
                />
              </ListItem>
              <Divider />
              <ListItem button onClick={onResetDWP}>
                <ListItemIcon style={{ color: 'white' }}>
                  <RotateLeft />
                </ListItemIcon>
                <ListItemText
                  primary="Reset Password Digital Work Permit"
                  classes={{ primary: classes.textNav }}
                />
              </ListItem>
              <Divider />
              <ListItem button onClick={onClickSignature}>
                <ListItemIcon style={{ color: 'white' }}>
                  <Gesture />
                </ListItemIcon>
                <ListItemText
                  primary="Signature"
                  classes={{ primary: classes.textNav }}
                />
              </ListItem>
              <Divider />
              <ListItem button onClick={onClickDWPLink}>
                <ListItemIcon style={{ color: 'white' }}>
                  <Print />
                </ListItemIcon>
                <ListItemText
                  primary="Print Digital Work Permit"
                  classes={{ primary: classes.textNav }}
                />
              </ListItem>
            </List>
          </div>
          <div className={classes.emp} />
          <div className={classes.paddingList}>
            <ColorButton
              fullWidth
              variant="contained"
              color="error"
              className={classes.logoutButton}
              onClick={handleClickLogout}
            >
              logout
            </ColorButton>
          </div>
        </div>

        <Popover
          className={classes.popover}
          classes={{
            paper: classes.popoverContent,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={popoverLeave}
        >
          <div className={classes.rowMenuPopOver}>
            <div className={classes.rowPopTitle}>Notifications</div>
            {notifications.length > 0 &&
              notifications.map((noti, index) => (
                <div
                  key={noti.notificationId}
                  className={classes.rowPopItem}
                  style={{
                    cursor: noti.data !== null ? "pointer" : "default",
                  }}
                  onClick={handleClickNotiItem(noti)}
                >
                  <div className={classes.firstItem}>
                    <div className={classes.itemTitle}>{noti.title}</div>
                    <div className={classes.itemDesc}>{noti.description}</div>
                    <div className={classes.itemDate}>
                      {format(new Date(noti.createDate), "yyyy-MM-dd HH:mm")}
                    </div>
                  </div>
                  <div
                    className={classes.secItem}
                    onClick={() => removeNotificaiton(noti.notificationId)}
                  >
                    <DeleteIcon />
                  </div>
                </div>
              ))}
            {notifications.length === 0 && (
              <div className={classes.noNoti}>No notifications yet</div>
            )}
          </div>
        </Popover>
      </Drawer>
    </div>
  );
}
